import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'space', 'Space', [["path",{"d":"M4 10v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-3"}]]);